import { Button } from "@material-ui/core";
import CryptoJS from "crypto-js";
import { AltaContext, EndosoContext } from "pages/endoso/context";
import { Fragment, useContext, useEffect, useState } from "react";
import { useHistory } from "react-router";
import { AuthContext } from "../../../../context/context";
import { endoso } from "../../../../services";
import {
  toConfirmDataCaratula,
  useRulesBy55,
} from "pages/endoso/hooks/ruleByTypes";
import { AlertModal, ColorBox } from "../../../../shared/components";
import { colors } from "../../../../shared/utils";
import {
  getMotivoAnulacionUnico,
  isCancelacionType,
  isDatosFiscalesCompleto,
  isDatosFiscalesType,
  TIPO_CANCELACION_MASIVA,
} from "../../../../shared/utils/endosoTypes";
import useStyles from "./styles";

const FooterSection = ({
  submit,
  setSpinner,
  showButtons,
  spinner,
  formDta,
  setShowButtons,
  setMessage,
  setShowMessage,
  data,
  dataSend,
  setDataContractor,
  suplemLogico,
  disableDraft = false,
}) => {
  const classes = useStyles();
  const history = useHistory();
  const {
    finishR21,
    setContinueR24,
    showAlcanceRFC,
    setShowAlcanceRFC,
    totalRecibos,
    confirmado25,
    setConfirmado25,
    showRefacturar,
    setShowRefacturar,
  } = useContext(EndosoContext);
  const { initialData } = useContext(AltaContext);
  const {
    setPersons,
    confirmData,
    setConfirmData,
    setTimer,
    showContinue,
    handleContinue,
    setHandleContinue,
    setShowBack,
    setOnlyApprove,
  } = useContext(AuthContext);
  const key = process.env.REACT_APP_URL_SECRET_KEY;
  const [haveMail, setHaveMail] = useState(false);
  /* HU8: paso de decision ANTES de ejecutar la cancelacion masiva
     (Continuar / Rechazar). Al confirmar no se muestra ningun modal extra:
     el flujo generico ya avisa por snackbar y monta la tabla de documentos. */
  const [confirmarCancelacion55, setConfirmarCancelacion55] = useState(false);
  const { handleEjecutarCancelacion55 } = useRulesBy55();

  /* methods */
  const handleCancelRequest = async () => {
    setTimer(0);
    setSpinner(true);
    await endoso.cancelRequest(formDta.noSolicitud);
    setSpinner(false);
    setPersons([]);
    setOnlyApprove([]);
    history.push("/");
  };
  const recoverData = async () => {
    setTimer(0);
    setSpinner(true);
    const configBody = {
      solicitud: formDta.noSolicitud,
      nivel: formDta.nivel,
      llave: formDta.llave ?? null,
      idPersona: null,
      idDomicilio: null,
    };
    const searchResponse = await endoso.configuration(configBody);
    if (searchResponse.data?.codigo === 1) {
      formDta.datosEndoso = searchResponse.data.datosEndoso;
      setShowButtons({ ...showButtons, infoTable: false });
    } else {
      setMessage({
        text: "SU SOLICITUD NO HA PODIDO SER PROCESADA",
        severity: "warning",
      });
      setShowMessage(true);
    }
    setSpinner(false);
  };

  const resetTexto24 = () => {
    setContinueR24(false);
    setShowButtons((prev) => ({ ...prev, infoTable: false }));
  };

  const getUsernameFromToken = () => {
    const tokenData = localStorage.getItem("token");

    if (tokenData) {
      try {
        const parsedToken = JSON.parse(tokenData);
        return parsedToken.username || null;
      } catch (error) {
        console.error("Error al parsear el token:", error);
        return null;
      }
    }

    return null;
  };

  const encryptUrl = (url) => {
    return CryptoJS.AES.encrypt(url, CryptoJS.enc.Utf8.parse(key), {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7,
    }).toString();
  };

  /**
   * Devuelve true si quedó armado el modal "Atención … Continuar" del SnackBar
   * (correo del contratante + envío OK). Solo lo consume el tipo 25 (HU6) para
   * saber si debe esperar ese Continuar o encadenar la refacturación directo;
   * los demás tipos ignoran el retorno y su comportamiento no cambia.
   *
   * En el tipo 25 TAMPOCO se prende aquí `showButtons.sendEmail`: ese flag
   * cambia toda la pantalla a la carátula (documentos), que en esta HU es la
   * vista FINAL. Si se prendiera junto con el modal, la carátula quedaría
   * pintada detrás de él. La libera `liberarCaratula25()` al terminar el flujo.
   */
  const sendEncryptedDocumentsEmail = async (
    confirmResponse,
    formDta,
    data
  ) => {
    setSpinner(true);
    const esDatosFiscales = isDatosFiscalesType(data.tipend);
    let modalContinuarArmado = false;
    const correoContratante = confirmResponse.data.correoContratante;
    if (correoContratante) {
      setMessage({
        text: "El endoso ha sido confirmado de manera satisfactoria. Has sido copiado en el correo que hemos enviado al contratante de la póliza con la documentación correspondiente al endoso realizado",
        severity: "success",
        action: true,
      });
    }

    const encryptedDocuments = confirmResponse.data?.documentos.map((doc) => ({
      ...doc,
      url: encryptUrl(doc.url),
    }));

    if (confirmResponse.data.correoContratante) {
      const resp = await endoso.sendDocumentsEmail({
        idSolicitud: formDta.noSolicitud,
        oficina: data.oficina,
        poliza: data.poliza,
        ramo: data.ramo,
        suplemento: suplemLogico ?? formDta.suplemLogico ?? 0,
        codigoEndoso: data.tipend,
        descripcionEndoso: data.descripcionEndoso,
        correoAgente: getUsernameFromToken(),
        correoContratante,
        documentos: encryptedDocuments,
      });

      if (resp.data?.codigo === 1 || resp.data?.codigo === "1") {
        setShowMessage(true);
        if (!esDatosFiscales)
          setShowButtons({ ...showButtons, sendEmail: true });
        setShowMessage(true);
        setConfirmData(confirmResponse.data || {});
        setHaveMail(true);
        setShowBack(true);
        setSpinner(false);
        modalContinuarArmado = true;
      }
    } else {
      if (!esDatosFiscales) setShowButtons({ ...showButtons, sendEmail: true });
      setMessage({
        text: "OCURRIO UN PROBLEMA CON EL ENVIO DE CORREOS",
        severity: "warning",
      });
      setShowMessage(true);
      setConfirmData(confirmResponse.data || {});
      setHaveMail(false);
    }
    setSpinner(false);
    return modalContinuarArmado;
  };

  useEffect(() => {
    if (showButtons.sendEmail || showButtons.formEmail) {
      setShowBack(false);
    }
  }, [showButtons, setShowBack]); // eslint-disable-line

  /**
   * Endoso 25 (HU6): libera la vista FINAL del flujo (carátula/documentos). Es
   * el único punto donde se prende sendEmail para este tipo, y por eso se llama
   * recién cuando ya no queda ningún paso pendiente. Forma funcional para no
   * pisar flags con una copia vieja de showButtons.
   */
  const liberarCaratula25 = () =>
    setShowButtons((prev) => ({
      ...prev,
      sendEmail: true,
      refacturacion25: false,
    }));

  /**
   * Endoso 25 (HU6): siguiente paso tras confirmar. Si hay recibos asociados
   * (total > 0) se ofrece la refacturación; si no, el flujo termina y se
   * muestra la carátula.
   */
  const continuarFlujo25 = () => {
    if (totalRecibos > 0) setShowRefacturar(true);
    else liberarCaratula25();
  };

  /**
   * Endoso 25 (HU6, iteración 2): encadena el modal "Continuar" del correo
   * (SnackBar, action:true) con el siguiente paso. confirmado25 significa
   * "confirmado, esperando ese Continuar". Guardado por isDatosFiscalesType
   * porque handleContinue también lo activan los tipos 12, 14 y 16.
   */
  useEffect(() => {
    if (!isDatosFiscalesType(data.tipend) || !confirmado25 || !handleContinue) {
      return;
    }
    setHandleContinue(false);
    setConfirmado25(false);
    continuarFlujo25();
  }, [handleContinue, confirmado25]); // eslint-disable-line

  /**
   * Endoso 25 (HU6): confirmación disparada al ACEPTAR el modal de alcance por
   * RFC, no por el botón del footer. Replica el bloque de confirmación directa
   * de confirmRequest a propósito (ADR-001) para no tocar sus condiciones
   * reguladas por rango de tipo.
   */
  const confirmarDatosFiscales = async () => {
    setTimer(0);
    setSpinner(true);
    setHandleContinue(false);
    try {
      const body = {
        idSolicitud: formDta.noSolicitud,
        oficina: data.oficina,
        poliza: data.poliza,
        ramo: data.ramo,
        suplemento: formDta.suplemLogico,
        cdTipo: "PE",
      };
      const confirmResponse = await endoso.confirma(body);
      setPersons([]);
      if (confirmResponse.data?.codigo === 1) {
        const modalContinuarArmado = await sendEncryptedDocumentsEmail(
          confirmResponse,
          formDta,
          data
        );
        if (dataSend) setDataContractor(dataSend);
        /* Si quedó armado el modal "Atención … Continuar" del SnackBar, el
         * flujo espera a que el usuario lo acepte (useEffect de
         * handleContinue); si no se armó (sin correo del contratante, o el
         * envío no devolvió codigo 1) se sigue directo para no quedar sin
         * salida. El paso extra de refacturación depende SOLO del total de
         * recibos que devolvió guarda-datos-fiscales (ver continuarFlujo25). */
        if (modalContinuarArmado) setConfirmado25(true);
        else continuarFlujo25();
      } else {
        setMessage({
          text: "OCURRIO UN PROBLEMA CON SU SOLICITUD",
          severity: "warning",
        });
        setShowMessage(true);
      }
    } catch (error) {
      setMessage({
        text: "OCURRIO UN PROBLEMA CON SU SOLICITUD",
        severity: "warning",
      });
      setShowMessage(true);
    } finally {
      setShowAlcanceRFC(false);
      setSpinner(false);
    }
  };

  /* Cancelacion con un solo Motivo de anulacion: el resumen se mostro sin
     guardar (backend marca la poliza "Cancelado" en endoso/guarda), asi que
     el guarda se hace aqui, justo antes de confirmar. */
  const guardarMotivoUnico = async () => {
    const guardaResponse = await endoso.saveEndoso({
      nivel: formDta.nivel,
      orden: 1,
      solicitud: formDta.noSolicitud,
      valor: getMotivoAnulacionUnico(data.tipend, formDta.datosEndoso),
    });
    if (guardaResponse.data?.codigo === 1) return true;
    setMessage({
      text:
        guardaResponse.data?.mensaje ||
        "SU SOLICITUD NO HA PODIDO SER PROCESADA",
      severity: "warning",
    });
    setShowMessage(true);
    return false;
  };

  /* HU8: en el tipo 55 el boton ya dice "Confirmar Endoso" cuando hay resumen
     (infoTable/multiTable). En ese punto no se ejecuta directo: primero se pide
     confirmacion explicita. En cualquier otro caso el comportamiento no cambia. */
  const requiereConfirmacionCancelacion = () =>
    Number(data.tipend) === TIPO_CANCELACION_MASIVA &&
    (showButtons.infoTable || showButtons.multiTable);

  const handleConfirmClick = () => {
    if (requiereConfirmacionCancelacion()) {
      setTimer(0);
      setConfirmarCancelacion55(true);
      return;
    }
    confirmRequest();
  };

  /* HU8 Paso 4: el tipo 55 NO usa el flujo generico de confirmacion: cancela
     poliza por poliza (bloquea, guarda, confirma, enviar_documentos) y al final
     la poliza origen. SI reutiliza la vista de caratula del proyecto: al prender
     `sendEmail`, formsSection monta el mismo FormTable check type={2} que ve el
     endoso de cancelacion, con los documentos de las polizas canceladas. */
  const ejecutarCancelacion = async () => {
    setTimer(0);
    setSpinner(true);
    try {
      const resultado = await handleEjecutarCancelacion55(
        formDta,
        data,
        ({ text, severity }) => {
          setMessage({ text, severity });
          setShowMessage(true);
        }
      );
      const caratula = toConfirmDataCaratula(resultado?.documentos);
      if (caratula) {
        setConfirmData(caratula);
        setShowButtons((prev) => ({ ...prev, sendEmail: true }));
        // Los documentos ya se enviaron por enviar_documentos: el boton del
        // pie pasa a "Finalizar" (vuelve al inicio) en vez de "Notificar".
        setHaveMail(true);
        setShowBack(true);
      }
    } catch (e) {
      setMessage({
        text: "OCURRIO UN PROBLEMA CON SU SOLICITUD",
        severity: "warning",
      });
      setShowMessage(true);
    } finally {
      setSpinner(false);
    }
  };

  const confirmRequest = async () => {
    try {
      setTimer(0);
      setSpinner(true);
      setHandleContinue(false);

      if (
        data.tipend === 12 &&
        !showButtons.infoTable &&
        !showButtons.multiTable
      ) {
        await submit();
        return;
      }

      if (
        showButtons.infoTable &&
        (data.tipend <= 20 || isCancelacionType(data.tipend))
      ) {
        if (data.tipend === 8 || data.tipend === 12) {
          const tarifaResponse = await endoso.tarifa({
            solicitud: formDta.noSolicitud,
          });
          if (tarifaResponse.data?.codigo === 1) {
            const body = {
              idSolicitud: formDta.noSolicitud,
              oficina: data.oficina,
              poliza: data.poliza,
              ramo: data.ramo,
              suplemento: formDta.suplemLogico,
              cdTipo: data.tipend >= 21 && data.tipend <= 23 ? "P" : "PE",
            };

            const confirmResponse = await endoso.confirma(body);
            setPersons([]);
            if (confirmResponse.data?.codigo === 1) {
              sendEncryptedDocumentsEmail(confirmResponse, formDta, data);
              if (dataSend) {
                setDataContractor(dataSend);
              }
            } else {
              setMessage({
                text: "OCURRIO UN PROBLEMA CON SU SOLICITUD",
                severity: "warning",
              });
              setShowMessage(true);
              const timer = setTimeout(() => history.push("/"), 2000);
              return () => clearTimeout(timer);
            }
          } else {
            setMessage({
              text: "OCURRIO UN PROBLEMA CON SU SOLICITUD",
              severity: "warning",
            });
            setShowMessage(true);
            setSpinner(false);
          }
        } else {
          if (showButtons.motivoAutomatico && !(await guardarMotivoUnico())) {
            setSpinner(false);
            return;
          }
          const body = {
            idSolicitud: formDta.noSolicitud,
            oficina: data.oficina,
            poliza: data.poliza,
            ramo: data.ramo,
            suplemento: formDta.suplemLogico,
            cdTipo: data.tipend >= 21 && data.tipend <= 23 ? "P" : "PE",
          };

          const confirmResponse = await endoso.confirma(body);
          setPersons([]);
          if (confirmResponse.data?.codigo === 1) {
            sendEncryptedDocumentsEmail(confirmResponse, formDta, data);
          } else {
            setMessage({
              text: "OCURRIO UN PROBLEMA CON SU SOLICITUD",
              severity: "warning",
            });
            setShowMessage(true);
            const timer = setTimeout(() => history.push("/"), 2000);
            return () => clearTimeout(timer);
          }
        }
      } else if (
        showButtons.multiTable ||
        (showButtons.infoTable && data.tipend >= 21)
      ) {
        const tarifaResponse = await endoso.tarifa({
          solicitud: formDta.noSolicitud,
        });
        if (tarifaResponse.data?.codigo === 1) {
          const body = {
            idSolicitud: formDta.noSolicitud,
            oficina: data.oficina,
            poliza: data.poliza,
            ramo: data.ramo,
            suplemento: formDta.suplemLogico,
            cdTipo: data.tipend >= 21 && data.tipend <= 23 ? "P" : "PE",
          };

          const confirmResponse = await endoso.confirma(body);
          setSpinner(true);
          setPersons([]);
          if (confirmResponse.data?.codigo === 1) {
            sendEncryptedDocumentsEmail(confirmResponse, formDta, data);
          } else {
            setMessage({
              text: "OCURRIO UN PROBLEMA CON SU SOLICITUD",
              severity: "warning",
            });
            setShowMessage(true);
            const timer = setTimeout(() => history.push("/"), 2000);
            return () => clearTimeout(timer);
          }
        } else {
          setMessage({
            text:
              tarifaResponse.data?.mensaje ||
              "OCURRIO UN PROBLEMA CON SU SOLICITUD",
            severity: "warning",
          });
          setShowMessage(true);
          if (data.tipend === 24) resetTexto24();
          setSpinner(false);
        }
      } else {
        await submit();
      }
    } catch (e) {
      // Red de seguridad: si una regla lanza, el overlay bloqueante de
      // formsSection quedaria encendido para siempre y taparia el formulario.
      setSpinner(false);
      setMessage({
        text: "OCURRIO UN PROBLEMA CON SU SOLICITUD",
        severity: "warning",
      });
      setShowMessage(true);
    }
  };
  const handleSendEmail = async () => {
    setTimer(0);
    if (haveMail) {
      const timer = setTimeout(() => history.push("/"), 2000);
      return () => clearTimeout(timer);
    } else {
      const encryptedDocuments = confirmData.documentos?.map((doc) => ({
        ...doc,
        url: encryptUrl(doc.url),
      }));

      if (showButtons.formEmail) {
        setSpinner(true);
        const body = {
          idSolicitud: formDta.noSolicitud,
          oficina: data.oficina,
          poliza: data.poliza,
          ramo: data.ramo,
          suplemento: formDta.suplemLogico,
          codigoEndoso: data.tipend,
          descripcionEndoso: data.descripcionEndoso,
          correoAgente: getUsernameFromToken(),
          correoContratante: confirmData.emailData.emailOne,
          documentos: encryptedDocuments,
        };

        const sendDocuments = await endoso.sendDocumentsEmail(body);

        if (sendDocuments.data?.codigo === 1) {
          setMessage({
            text: "SE HA REALIZADO SU SOLICITUD SATISFACTORIAMENTE",
            severity: "success",
          });
          setShowMessage(true);
          const timer = setTimeout(() => history.push("/"), 2000);
          return () => clearTimeout(timer);
        } else {
          setMessage({
            text:
              sendDocuments.data?.mensaje ||
              "OCURRIO UN PROBLEMA CON SU SOLICITUD",
            severity: "warning",
          });
          setShowMessage(true);
        }

        setSpinner(false);
      } else {
        if (
          (confirmData.documents && confirmData.documents.length > 0) ||
          (confirmData.documentos && confirmData.documentos.length > 0)
        ) {
          setShowButtons({ ...showButtons, formEmail: true });
        } else {
          setMessage({
            text: "DEBE SELECCIONAR AL MENOS UN DOCUMENTO",
            severity: "warning",
          });
          setShowMessage(true);
        }
      }
    }
  };
  /* El RFC del modal es el mostrado en pantalla, no se vuelve a consultar. */
  const rfcContratante =
    dataSend?.RFC ??
    formDta.datosEndoso?.find((dato) => dato.acronimo === "RFC")?.valorActual ??
    "";

  return (
    <div className={classes.root}>
      {showAlcanceRFC && (
        <AlertModal
          open={showAlcanceRFC}
          title="Atención"
          icon
          message={`Este movimiento se aplicará en todas las pólizas donde este se tenga el RFC ${rfcContratante}`}
          SuccessText="Aceptar"
          CancelText="Rechazar"
          success={confirmarDatosFiscales}
          close={() => {
            /* Rechazar (HU6): no se aplica ningún cambio. El borrador queda
             * guardado para que el usuario o un proceso automático lo
             * cancelen después; no se navega ni se reintenta el timbrado. */
            setShowAlcanceRFC(false);
            setShowButtons({ ...showButtons, guardarEndoso: false });
            setMessage({
              text: "EL BORRADOR QUEDÓ GUARDADO Y NO SE APLICÓ NINGÚN CAMBIO",
              severity: "info",
            });
            setShowMessage(true);
          }}
          loading={spinner}
        />
      )}
      {showRefacturar && (
        <AlertModal
          open={showRefacturar}
          title="Atención"
          icon
          message="Se han actualizado Régimen Fiscal y CP receptor ¿requiere refacturar?"
          SuccessText="Refacturar"
          CancelText="No"
          success={() => {
            setShowRefacturar(false);
            setShowButtons((prev) => ({ ...prev, refacturacion25: true }));
          }}
          /* "No": el flujo termina aquí, así que se libera la carátula. */
          close={() => {
            setShowRefacturar(false);
            liberarCaratula25();
          }}
        />
      )}
      {/* Decision previa: Rechazar no genera cancelacion alguna. */}
      <AlertModal
        open={confirmarCancelacion55}
        close={() => setConfirmarCancelacion55(false)}
        success={() => {
          setConfirmarCancelacion55(false);
          ejecutarCancelacion();
        }}
        title="Confirmar cancelación"
        message="¿Desea continuar con la cancelación de pólizas de acuerdo con la fecha mencionada?"
        SuccessText="Continuar"
        CancelText="Rechazar"
        type={1}
      />
      <div className={classes.section}>
        <ColorBox color={colors.blueSoft} legend="Vigente" />

        <ColorBox color={colors.redSpecial} legend="Especial" />
      </div>
      <div className={classes.actions}>
        {showButtons.refacturacion25 ? (
          <Fragment>
            <Button
              variant="text"
              className={classes.button}
              disabled={spinner}
              /* Omitir: el flujo termina y recién ahí se muestra la carátula. */
              onClick={liberarCaratula25}
            >
              <strong>Omitir refacturación</strong>
            </Button>
          </Fragment>
        ) : !showButtons.sendEmail ? (
          <Fragment>
            {showButtons.infoTable &&
              !showButtons.motivoAutomatico &&
              data.tipend !== 8 &&
              data.tipend !== 6 &&
              data.tipend !== 7 &&
              data.tipend !== 12 &&
              data.tipend !== 16 &&
              data.tipend !== 20 &&
              data.tipend !== 21 &&
              data.tipend !== 22 &&
              data.tipend !== 23 &&
              data.tipend !== 24 &&
              data.tipend !== 26 && (
                <Button
                  variant="text"
                  className={classes.button}
                  onClick={recoverData}
                  disabled={spinner}
                >
                  <strong>Modificar</strong>
                </Button>
              )}
            <Button
              variant="text"
              className={classes.button}
              onClick={() => {
                handleCancelRequest();
                setPersons([]);
                setOnlyApprove([]);
              }}
              disabled={spinner || !formDta.nivel}
            >
              <strong>Cancelar</strong>
            </Button>
            {(showButtons.infoTable || showButtons.multiTable) &&
            initialData?.formaAseguramiento === "002" ? (
              <> </>
            ) : (
              showButtons.guardarEndoso &&
              !formDta.mensaje && (
                <Button
                  variant="text"
                  className={classes.button}
                  onClick={handleConfirmClick}
                  disabled={
                    (disableDraft &&
                      initialData?.formaAseguramiento !== "002") ||
                    spinner ||
                    !formDta.nivel ||
                    (showContinue &&
                      (data.tipend === 16 || data.tipend === 14)) ||
                    (data.tipend === 6 && showButtons.disableSix) ||
                    (data.tipend === 21 &&
                      Object.keys(finishR21).length === 0) ||
                    (data.tipend === 22 && showButtons.disableTwentyTwo) ||
                    (data.tipend === 23 && showButtons.disableTwentyThree) ||
                    (isDatosFiscalesType(data.tipend) &&
                      !isDatosFiscalesCompleto(dataSend))
                  }
                >
                  {(showButtons.infoTable || showButtons.multiTable) &&
                  initialData?.formaAseguramiento !== "002" ? (
                    <strong>Confirmar Endoso</strong>
                  ) : (
                    <strong>Guardar Borrador</strong>
                  )}
                </Button>
              )
            )}
          </Fragment>
        ) : (
          <Fragment>
            {/* HU8: en el tipo 55 la cancelacion ya se ejecuto; solo queda
                "Finalizar", no se muestra el "Cancelar" deshabilitado. */}
            {Number(data.tipend) !== TIPO_CANCELACION_MASIVA && (
              <Button
                variant="text"
                className={classes.button}
                disabled={true}
                onClick={() => {
                  setTimer(0);
                  setConfirmData({});
                  history.push("/");
                }}
              >
                <strong>Cancelar</strong>
              </Button>
            )}
            <Button
              variant="text"
              className={classes.button}
              onClick={handleSendEmail}
              disabled={showButtons.disableSend || spinner}
            >
              <strong>
                {haveMail
                  ? "Finalizar"
                  : showButtons.formEmail
                  ? "Enviar"
                  : "Notificar"}
              </strong>
            </Button>
          </Fragment>
        )}
      </div>
    </div>
  );
};

export default FooterSection;
